import { KeycloakConfig } from 'keycloak-js'
import { environment } from 'src/environments/environment';

export const keycloakConfig: KeycloakConfig = {
    
    url: environment.keyCloakUrl,
    realm: environment.keyCloackRealm,//'corp-mrch',
    clientId: 'rebate-services'
}